module.exports = __webpack_public_path__ + "img/haiwan.3c68be81.png";